import { ComponentView, ObservableArray, View } from "binder"
import { FilesListViewModel, fileWrapper } from "./filesList-viewModel"

export class FilesListView extends ComponentView<FilesListViewModel>{
    GetViewUniqueId(): string {
        return "V-B7418C28-918B-4E95-BA39-E15DAFF589C2"
    }
    loadHtml(): string {
        let element = require('./filesList.html').default;
        let style = require('./filesList.less');
        return element;
    }
    constructor() {
       super();
    }

    public set isreadonly(v: boolean) { this._isreadonly = v; } public get isreadonly(): boolean { return this._isreadonly;} private _isreadonly: boolean;
    public set items(v: ObservableArray<fileWrapper>) { this._items = v; } public get items(): ObservableArray<fileWrapper> { return this._items;} private _items: ObservableArray<fileWrapper>;
    public set issingle(v: boolean) { this._issingle = v; } public get issingle(): boolean { return this._issingle;} private _issingle: boolean;

    add(){
        this.dataContext.add();
    }

    listColumnSpanConverter(v){
        if(v==true){
            return 1;
        }
        return 2;
    }
    addButtonRowNo(v){
        if(v==true){
            return 1;
        }
        return 3;
    }
}
